export const useSelectorElement = (selector) => {
  const { onLoop } = useRenderLoop()

  const ele = ref()

  const updateEle = () => {
    ele.value = document.querySelector(selector)
  }

  watch(() => selector, updateEle)

  onMounted(async () => {
    await nextTick()
    await delay(100)
    updateEle()
  })

  usePageEnter(updateEle)

  onLoop(() => {
    if (ele.value) return
    updateEle()
  })

  return ele
}
